import React, { useState } from 'react';
import styled from 'styled-components';
import CarrierRecordTable from './CarrierRecordTable/CarrierRecordTable';
import GasoilModal from './GasoilModal';

const TableWrap = styled.div`
  .gasoil-list,
  .local-gas-station {
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
  }
`;

const CarrierRecordView = () => {
  const [openModal, setOpenModal] = useState(false);
  const [typeContentModal, setTypeContentModal] = useState('');
  const [shipmentId, setShipmentId] = useState('');
  const [historyItem, setHistoryItem] = useState('');

  return (
    <>
      <TableWrap>
        <CarrierRecordTable />
      </TableWrap>
      <GasoilModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        typeContentModal={typeContentModal}
        shipmentId={shipmentId}
        historyItem={historyItem}
      />
    </>
  );
};

export default CarrierRecordView;
